import { Contact } from "../models/Contact";

var contacts: Contact[] = [
    {
        country: "Poland",
        countryCode: "PL",
        phoneNumbers: ["+495661 71-1110"]
    },
    {
        country: "Germany",
        countryCode: "DE",
        phoneNumbers: ["+495661 71-1111", "+497461 95-1111"]
    },
    {
        country: "Switzerland",
        countryCode: "CH",
        phoneNumbers: ["+41 582587667 (German)", "+41 582587666 (French)"]
    },
    {
        country: "Spain",
        countryCode: "ES",
        phoneNumbers: ["+34 935866611"]
    },
    {
        country: "Portugal",
        countryCode: "PT",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Brazil",
        countryCode: "BR",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Argentina",
        countryCode: "AR",
        phoneNumbers: ["+54 4954-2030"]
    },
    {
        country: "Chile",
        countryCode: "CL",
        phoneNumbers: ["+56 2 24407111"]
    },
    {
        country: "Peru",
        countryCode: "PE",
        phoneNumbers: ["+51 1 3261825"]
    },
    {
        country: "Paraguay",
        countryCode: "PY",
        phoneNumbers: ["+595 021752480"]
    },
    {
        country: "Ecuador",
        countryCode: "EC",
        phoneNumbers: ["+ 593 2481200"]
    },
    {
        country: "El Salvador",
        countryCode: "SV",
        phoneNumbers: ["+503 25244011"]
    },
    {
        country: "Mexico",
        countryCode: "MX",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Columbia",
        countryCode: "CO",
        phoneNumbers: ["+57 1 7470329"]
    },
    {
        country: "Malaysia",
        countryCode: "MY",
        phoneNumbers: ["+604 632 3030"]
    },
    {
        country: "Russia",
        countryCode: "RU",
        phoneNumbers: ["+7 8123204004"]
    },
    {
        country: "Norway",
        countryCode: "NO",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Denmark",
        countryCode: "DK",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Finland",
        countryCode: "FI",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Ireland",
        countryCode: "IE",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "United Kingdom",
        countryCode: "UK",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "France",
        countryCode: "FR",
        phoneNumbers: ["+33 1 41 10 53 53"]
    },
    {
        country: "Italy",
        countryCode: "IT",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Sweden",
        countryCode: "SE",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "South Africa",
        countryCode: "ZA",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Serbia",
        countryCode: "RS",
        phoneNumbers: ["+385 1 7789 402"]
    },
    {
        country: "Estonia",
        countryCode: "EE",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Croatia",
        countryCode: "HR",
        phoneNumbers: ["+385 1 7789 402"]
    },
    {
        country: "Hungary",
        countryCode: "HU",
        phoneNumbers: ["+36-1 346 9777"]
    },
    {
        country: "Romania",
        countryCode: "RO",
        phoneNumbers: ["+40 372 566 499"]
    },
    {
        country: "Bulgaria",
        countryCode: "BG",
        phoneNumbers: ["+359 2 8076799"]
    },
    {
        country: "Latvia",
        countryCode: "LV",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Czech Republic",
        countryCode: "CZ",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Lithuania",
        countryCode: "LT",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Kazakhastan",
        countryCode: "KZ",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Ukraine",
        countryCode: "UA",
        phoneNumbers: ["Toll Free number - 0800302003 -"]
    },
    {
        country: "Belgium / Netherlands",
        countryCode: "BE / NL",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Austria",
        countryCode: "AT",
        phoneNumbers: ["+49 5661 71-1111"]
    },
    {
        country: "Taiwan",
        countryCode: "TW",
        phoneNumbers: ["+604 632 3030"]
    }
];

export default contacts;
